import { actions, useFormSelector } from '../../../slice';

export default () => {
  const employee = useFormSelector((state) => state.employee);

  return {
    value: employee?.name,
    onEditClick: () => actions.setFormVariable(["employee", undefined]),
  };
};
